import './spinner.css';

function Spinner(): JSX.Element {
  return (
    <div className="spinner">
      <div className="spinner__circle"></div>
    </div>
  );
}

export default Spinner;
